<script setup lang="ts">
import { ref } from "vue";

const customName = ref("Ali");
const lastRun = ref("Guest");

function runGuest() {
  lastRun.value = "Guest";
}

function runCustom() {
  lastRun.value = customName.value.trim() || "Guest";
}
</script>

<template>
  <section class="rounded-3xl border border-slate-200 bg-slate-50 p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Default Parameters</h2>
      <p class="text-sm text-slate-600">Agar value na do to default value use hoti hai.</p>
    </div>

    <pre class="mt-4 overflow-x-auto rounded-2xl bg-slate-950 p-4 text-xs leading-6 text-slate-100"><code>def greet(name="Guest"):
    print(name)</code></pre>

    <div class="mt-4 flex flex-wrap gap-2">
      <button type="button" class="rounded-full bg-slate-950 px-4 py-2 text-sm font-medium text-white" @click="runGuest">
        Run greet()
      </button>
      <input v-model="customName" type="text" class="rounded-full border border-slate-200 px-4 py-2 text-sm" placeholder="Ali">
      <button type="button" class="rounded-full bg-white px-4 py-2 text-sm font-medium text-slate-900 ring-1 ring-slate-200" @click="runCustom">
        Run greet("Ali")
      </button>
    </div>

    <div class="mt-4 rounded-2xl bg-white p-4 ring-1 ring-slate-200">
      <p class="text-xs font-semibold uppercase tracking-wide text-slate-500">Output</p>
      <p class="mt-2 text-sm font-medium text-slate-900">{{ lastRun }}</p>
    </div>
  </section>
</template>
